window.addEventListener('load', () => {
    const modals = document.querySelectorAll<HTMLElement>('.modal');
    const url_hash = window.location.hash;

    modals.forEach(modal => {
        const type = modal.getAttribute('data-modal-type');
        const button = document.querySelector('.modal-toggle--' + type);
        const modal_contains_hash = url_hash && modal.querySelector(url_hash);

        button?.addEventListener('click', () => {
            modal.classList.toggle('active');
        });

        modal.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            if (target.classList.contains('modal') || target.classList.contains('modal-close')) {
                modal.classList.remove('active');

                if (modal_contains_hash) {
                    history.replaceState(null, '', ' ');
                }
            }
        });

        if (modal_contains_hash) {
            modal.classList.add('active');
        }
    });
});
